import Store from 'store/store';
import { visibleRatio } from 'utils/visibilityChecks';

Store.on('FOOTER_AUTO_EXPANDED', () => {
	Store.get().footer.set({ allowAutoExpand: false });
});

Store.on('UPDATE_FOOTER_ACTIVE_PERCENTAGE', () => {
	let footerElem = document.querySelector('[data-section=boltFooter]');
	let percentage = visibleRatio(footerElem);
	if (percentage === undefined) return;
	let footerStore = Store.get().footer;
	let rounded = Math.ceil(percentage * 10) / 10;
	if (rounded !== footerStore.footerActivePercentage) {
		footerStore.set({ activePercentage: rounded });
	}
});

Store.on('UPDATE_VISIBILITY_PERCENTAGES', () => Store.emit('UPDATE_FOOTER_ACTIVE_PERCENTAGE'));
